export default __webpack_public_path__ + "static/media/Instagram.c8766fed.svg";